import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { IriumInputModule } from "../../gyzmo-commons/components/irium-input/irium-input.module";
import { DepartureCardSkeletonModule } from "../components/departure-card-skeleton/departure-card-skeleton.module";
import { ReturnSearchResultComponentModule } from "../components/return-search-result/return-search-result.module";
import { TitleBarModule } from "../components/title-bar/title-bar.module";

import { ContractSearchPageRoutingModule } from "./contract-search-routing.module";

import { ContractSearchPage } from "./contract-search.page";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ContractSearchPageRoutingModule,
        IriumInputModule,
        DepartureCardSkeletonModule,
        ReturnSearchResultComponentModule,
        TitleBarModule,
        TranslateModule,
    ],
    declarations: [ContractSearchPage],
})
export class ContractSearchPageModule {
}
